import { render, staticRenderFns } from "./MedicalLabel.vue?vue&type=template&id=0e8f4179&"
import script from "./MedicalLabel.vue?vue&type=script&lang=js&"
export * from "./MedicalLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports